export const setFontWeightClassNames = (fontWeight, setFontWeightClassNamesCallback) => {
  if (fontWeight === null || fontWeight === undefined) {
    setFontWeightClassNamesCallback('force-font__light')
  } else {
    switch (fontWeight) {
      case 300:
        setFontWeightClassNamesCallback('force-font__light')
        break
      case 500:
        setFontWeightClassNamesCallback('force-font__bold')
        break
      case 700:
        setFontWeightClassNamesCallback('force-font__heavy')
        break
      default:
        setFontWeightClassNamesCallback('force-font__light')
        break
    }
  }
}
